import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  Flex,
  IconButton,
  useToast,
} from '@chakra-ui/react'
import { InfoDevolucao } from './InfoDevolucao'
import { ObservacoesFornecedor } from './ObservacoesFornecedor'
import { VisualizarFotos } from './VisualizarFotos'
import { useForm } from 'react-hook-form'
import { useEffect, useState } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { baseURL } from '../../../../services/api'
import { AiFillFilePdf } from 'react-icons/ai'

const schema = yup.object().shape({
  pedidoFornecedor: yup.string().required('Campo obrigatório'),
  observacaoFornecedor: yup.string().required('Campo obrigatório'),
  email: yup
    .string()
    .required('Campo obrigatório')
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, 'Email inválido'),

  email_0: yup.string().matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, 'Email inválido'),
  email_1: yup.string().matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, 'Email inválido'),
})

export const ModalDevolucao = ({
  open,
  onClose,
  dataModal,
  modalOpen,
  fotoView,
  setFotoView,
  obsFornecedor,
  dadosModal,
  dadosObservacoes,
  submitForm,
}) => {
  const {
    register,
    handleSubmit,
    setFocus,
    reset,
    formState: { isSubmitting, errors },
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  })

  const [loading, setLoading] = useState(false)
  const [loadingGerar, setLoadingGerar] = useState(false)
  const [loadingCreditar, setLoadingCreditar] = useState(false)
  const [clickPDF, setClickPDF] = useState(false)

  const [type, setType] = useState('pedido')

  const toast = useToast()

  const onSubmit = async (data) => {
    setLoading(true)
    const params = {
      observacao: data.observacaoFornecedor,
      numero_nota: dataModal.numero_nota,
      cod_prod: dataModal.codigo_produto,
      sequencia: dataModal.sequencia,
      pedido: data.pedidoFornecedor,
      email: data.email,
      email_2: data.email_0 ? data.email_0 : 'sistema3@innovationbrindes.com.br',
      email_3: data.email_1 ? data.email_1 : 'sistema3@innovationbrindes.com.br',
    }
    try {
      const response = await baseURL.post('/pedido/envia-dados-fornecedor-devolucao', params)
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(Object.keys(error), error.message)
    }
    reset()
    onClose()
    submitForm({ pendente: 'S' })
  }

  function closeModal() {
    reset()
    onClose()
  }

  async function gerarPedido(data) {
    try {
      setLoadingGerar(true)

      const params = {
        vlr_unit: dataModal.valor_unitario_pedido,
        vlr_total: dataModal.valor_total_pedido,
        sequencia: dataModal.sequencia,
        cod_prod: dataModal.codigo_produto,
        nunota: dataModal.pedido_compra,
        numero_nota: dataModal.numero_nota,
        email: data.email,
        email2: data.email_0 ? data.email_0 : 'sistema3@innovationbrindes.com.br',
        email3: data.email_1 ? data.email_1 : 'sistema3@innovationbrindes.com.br',
        obs: data.observacaoFornecedor,
      }

      const response = await baseURL.post('/pedido/atualiza-devolucao-troca-b1', params)

      toast({
        title: 'Pedido gerado com sucesso! seu pdf já está disponível.',
        status: 'success',
        position: 'top-right',
        duration: 5000,
        isClosable: true,
      })

      setClickPDF(true)
      setLoadingGerar(false)
      // submitForm({ pendente: 'S' });
      reset()
    } catch (error) {
      console.log(error)
      setLoadingGerar(false)

      toast({
        title: 'Erro ao gerar pedido. Contate o suporte.',
        status: 'error',
        position: 'top-right',
        duration: 5000,
        isClosable: true,
      })
    }

    setLoadingGerar(false)
  }

  async function gerarCrédito(data) {
    setLoadingCreditar(true)
    const params = {
      vlr_unit: dataModal.valor_unitario_pedido,
      vlr_total: dataModal.valor_total_pedido,
      sequencia: dataModal.sequencia,
      cod_prod: dataModal.codigo_produto,
      nunota: dataModal.pedido_compra,
      numero_nota: dataModal.numero_nota,
      email: data.email,
      email2: data.email_0 ? data.email_0 : 'sistema3@innovationbrindes.com.br',
      email3: data.email_1 ? data.email_1 : 'sistema3@innovationbrindes.com.br',
      obs: data.observacaoFornecedor,
    }

    const response = await baseURL.post('/pedido/atualiza-devolucao-troca-b2', params)

    setLoadingCreditar(false)

    reset()
    onClose()
    submitForm({ pendente: 'S' })
  }

  function gerarPDF() {
    window.open(`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-pdf-troca-fornecedor/${dadosModal.pedido_compra}`)

    setTimeout(() => {
      onClose()
      setClickPDF(false)
    }, 2000)
  }

  useEffect(() => {
    if (dadosModal?.numero_xbz !== '') {
      setValue('pedidoFornecedor', dadosModal?.numero_xbz)
    }
  }, [dadosModal])

  return (
    <>
      {!!modalOpen && (
        <Modal isOpen={open} size="5xl">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader textAlign="center">Devolução</ModalHeader>
            <ModalCloseButton
              boxShadow="none !important"
              onClick={() => {
                closeModal()
              }}
            />
            <ModalBody
              as="form"
              onSubmit={handleSubmit(dadosModal.codigo_parceiro !== '24' ? onSubmit : type === 'pedido' ? gerarPedido : gerarCrédito)}
            >
              <InfoDevolucao setFocus={setFocus} data={dataModal} register={register} errors={errors} />
              <ObservacoesFornecedor
                dadosObservacoes={dadosObservacoes}
                register={register}
                data={dataModal}
                obsFornecedor={obsFornecedor}
                reset={reset}
                errors={errors}
              />
              <VisualizarFotos fotoView={fotoView} setFotoView={setFotoView} dadosModal={dadosModal} />
              <Flex bg="gray.200" py="1rem" alignItems="center" justifyContent="center" mb="1rem">
                <Text textAlign="center" color="#378BBF">
                  OBSERVAÇÕES PRODUÇÃO
                </Text>
              </Flex>
              <Text pl="15px" fontWeight={600}>
                {dadosModal.observacao}
              </Text>

              {dadosModal.codigo_parceiro !== '24' && (
                <Flex alignItems="center" justifyContent="center">
                  <Button type="submit" colorScheme="blue" mt="1rem" isLoading={loading}>
                    ENCAMINHAR PARA O FORNECEDOR
                  </Button>
                </Flex>
              )}
              {dadosModal.codigo_parceiro === '24' && (
                <Flex alignItems="center" justifyContent="center" gap={2}>
                  <Button
                    type="submit"
                    colorScheme="blue"
                    mt="1rem"
                    isLoading={loadingCreditar}
                    onClick={() => {
                      setType('credito')
                    }}
                  >
                    Gerar crédito
                  </Button>
                  <Button
                    type="submit"
                    colorScheme="blue"
                    mt="1rem"
                    isLoading={loadingGerar}
                    onClick={() => {
                      setType('pedido')
                    }}
                  >
                    Gerar pedido
                  </Button>
                </Flex>
              )}
            </ModalBody>

            <ModalFooter>
              {dadosModal.codigo_parceiro === '24' && (
                <Flex alignItems="center" justifyContent="center" gap={2}>
                  <Button py={3} size="md" color="#ff0000" _focus={{ boxShadow: 'none' }} disabled={!clickPDF} onClick={gerarPDF}>
                    <IconButton as={AiFillFilePdf} paddingBlock=".3rem" bg="transparent" />
                    Gerar PDF
                  </Button>
                </Flex>
              )}
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </>
  )
}
